import React, {useEffect, useRef, useState} from "react";
import {injectIntl} from "react-intl";

function LinkListItem ({intl, title, links}) {
  const MAX_ITEMS = process.env.REACT_APP_SEO_COMPONENT_MAX_ITEMS_PER_COLUMN;
  const [isOpen, setIsOpen] = useState(false);
  const collapseContent = useRef();

  const toggleShowMore = () => {
    setIsOpen(isOpen => !isOpen);
  }

  useEffect(() => {
    if (isOpen) {
      const listHeight = collapseContent.current.querySelector('ul').clientHeight;
      collapseContent.current.style.maxHeight = `${listHeight}px`;
    }
  }, [isOpen]);

  const getRenderedItems = () => {
    if (isOpen) {
      return links;
    }
    return links.slice(0, MAX_ITEMS);
  }

  return (
    <div className="seo-links__column divider">
      <div className="collapsible__trigger" data-rs-collapsible={true} role="button" aria-expanded={false}>
        <span className="seo-links__title">
            { title }
          <span className="collapsible__button"/>
        </span>
      </div>
      <div className="collapsible__content" data-rs-collapsible-content={true} aria-hidden={true} ref={collapseContent}>
        <ul>
          {
            getRenderedItems().map((item, itemKey) => {
                return (
                  <li key={itemKey}>
                    <a href={item.url}>
                      {process.env.REACT_APP_USE_LOWER_CASE === "true" ? item.title.toLowerCase() : item.title}
                    </a>
                  </li>
                );
              })
          }
          {links.length > MAX_ITEMS ?
            (!isOpen ? <li><span className="show-more__link" onClick={toggleShowMore}>{intl.formatMessage({id: 'Branches.LinkList.ShowMore'})} (+)</span></li>
              : <li><span className="show-more__link" onClick={toggleShowMore}>{intl.formatMessage({id: 'Branches.LinkList.ShowLess'})} (-)</span></li>)
            : null }
        </ul>
      </div>
    </div>
  );
}

export default injectIntl(LinkListItem);
